<div *ngIf="category" class="category-header">
	<img ada-decorative class="scenario-image" [src]="categoryImagePath" onerror="this.style.display = 'none'" />
	<h4 class="text-16-bold">{{ categoryName }}</h4>
</div>
<div class="d-flex flex-wrap flex-direction-column padding-right-30">
	<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
	<sc-scenario
		*ngFor="let scenario of scenarios"
		[scenario]="scenario"
		[ngClass]="{ featured: isFeatured(scenario.rawValue) }"
		[isSelected]="isSelected(scenario.rawValue)"
		[showInfoBubbles]="showInfoBubbles"
		(onSelect)="updateSelect(scenario.rawValue, 'SELECT')"
		(onDeselect)="updateSelect(scenario.rawValue, 'DESELECT')"
	>
	</sc-scenario>
</div>
